import NavBar from "../../../components/NavBar";

import List from "../../../components/List";
import { hideAccount, big2num, getFix2, fmoney } from "../../../utils/utils";
import styled from "styled-components";
import { Grid, Toast } from "antd-mobile";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useContract from "../../../hooks/useContract";
import { useEffect } from "react";
import useWallet from "../../../hooks/Wallet/useWallet";
import { getHistory } from "../../../api";
import useTansferModal from "./useTansferModal";
import useTransaction from "../../../hooks/useTransaction";
import useGlobal from "../../../hooks/useGlobal";
import { BigNumber, ethers } from "ethers";
import { useIntl } from "react-intl";
import useCommon from "../../../hooks/Common/useCommon";

export default function RB() {
  const navigate = useNavigate();
  const { getRBBalance, getRBAllowance, setRBAllowance, getRBContract } =
    useContract();
  const { myAccount } = useWallet();
  const { getTxOptions} = useGlobal();
  const [rbBalance, setRbBalance] = useState(0);
  const [active, setActive] = useState(2);
  const [list, setList] = useState([]);
  const transferModal = useTansferModal();
  const intl = useIntl();
  const { lang } = useCommon();
  const { sendTransaction } = useTransaction({ intl });
  useEffect(() => {
    if (myAccount) {
      init();
    }
  }, [myAccount]);
  const init = async () => {
    const rb = await getRBBalance();
    setRbBalance(getFix2(big2num(rb)));
    change(2);
  };

  const change = async (type) => {
    if (!myAccount) return;
    setActive(type);
    const t = Toast.show({
      icon: "loading",
      duration: 0,
      content: intl.formatMessage({
        id: "common.loading",
        defaultMessage: "加載中...",
      }),
    });
    const res = await getHistory({
      addr: myAccount.account,
      transfer_type: type,
      lang: lang === 'en' ? 'en' : 'cn',
    });
    setList(res.data.list);
    t.close();
  };

  const buy = async () => {
    console.log("buy");
    window.location.href = "https://app.upswap.org/";
  };

  const transfer = async () => {
    console.log("transfer");
    window.location.href = "https://app.upswap.org/";
  };
  const transaction = async () => {
    console.log("transaction");
    const m = transferModal.show({
      onConfrim: async (data) => {
        console.log("buy out", data);
        if (!data.amount) {
          Toast.show({
            content: intl.formatMessage({
              id: "pages.runbit.transaction_amount_emtpy_error",
              defaultMessage: "請輸入轉出金額",
            }),
          });
          return;
        }

        if (!/^\d*$/.test(data.amount)) {
          Toast.show({
            content: intl.formatMessage({
              id: "pages.runbit.transaction_amount_error",
              defaultMessage: "轉出金額错误",
            }),
          });
          return;
        }
        if (!data.address) {
          Toast.show({
            content: intl.formatMessage({
              id: "pages.runbit.transaction_address_empty_error",
              defaultMessage: "請輸入接收地址",
            }),
          });
        }
        if (!ethers.utils.isAddress(data.address)) {
          Toast.show({
            content: intl.formatMessage({
              id: "pages.runbit.transaction_address_error",
              defaultMessage: "接收地址错误",
            }),
          });
          return;
        }

        const pow = BigNumber.from(10).pow(18);
        const amount = BigNumber.from(data.amount).mul(pow);
        await sendTransaction(
          getRBBalance,
          data.amount,
          getRBAllowance,
          setRBAllowance,
          async () => {
            const contract = await getRBContract();
            const gaslimit = await contract.estimateGas.transfer(
              data.address, amount
            );
            const opts = await getTxOptions(gaslimit)
            let tx = await contract.transfer(data.address, amount, opts);
            return tx;
          }
        );
        m.close();
        Toast.show({
          content: intl.formatMessage({
            id: "pages.runbit.transaction_success",
            defaultMessage: "交易成功",
          }),
          icon: "success",
        });
        init();
      },
    });
  };
  const headers = [
    {
      prop: "tx_hash",
      render: (val) => {
        return hideAccount(val);
      },
    },
    {
      prop: "value",
      render: (val) => {
        return <Amount>{fmoney(val, 0)} RT</Amount>;
      },
    },
    {
      prop: "create_time",
      render: (val) => {
        return val.split(" ")[0];
      },
    },
  ];
  return (
    <>
      <NavBar
        title={"RUNBIT"}
        Right={() => (
          <>
            <img
              onClick={() => {
                navigate("/user");
              }}
              src="/image/setting.png"
              alt="setting"
            />
          </>
        )}
      ></NavBar>
      <Wrapper>
        <div style={{ textAlign: "center" }}>
          <img width={"5.2rem"} src="/image/rb4.png" alt={""} />
          <Price>{fmoney(rbBalance, 0)} RT</Price>
        </div>
        <Grid columns={3} style={{ marginTop: "2.5rem" }}>
          <Grid.Item className="text-center" onClick={buy}>
            <img width={"5.8rem"} src="/image/rb1.png" alt={""} />
            <Label>
              {intl.formatMessage({
                id: "pages.runbit.buy",
                defaultMessage: "購買",
              })}
            </Label>
          </Grid.Item>
          <Grid.Item className="text-center" onClick={transaction}>
            <img width={"5.8rem"} src="/image/rb2.png" alt={""} />
            <Label>
              {intl.formatMessage({
                id: "pages.runbit.transfer",
                defaultMessage: "轉移",
              })}
            </Label>
          </Grid.Item>
          <Grid.Item className="text-center" onClick={transfer}>
            <img width={"5.8rem"} src="/image/rb3.png" alt={""} />
            <Label>
              {intl.formatMessage({
                id: "pages.runbit.transaction",
                defaultMessage: "交易",
              })}
            </Label>
          </Grid.Item>
        </Grid>
        <TabRow>
          <TabText active={active === 2} onClick={() => change(2)}>
            {intl.formatMessage({
              id: "pages.runbit.in",
              defaultMessage: "轉入",
            })}
          </TabText>
          <TabText active={active === 1} onClick={() => change(1)}>
            {intl.formatMessage({
              id: "pages.runbit.out",
              defaultMessage: "轉出",
            })}
          </TabText>
        </TabRow>
        <List list={list} header={headers} />
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  padding: 0 2.0rem;
`;

const Price = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 2.8rem;
  line-height: 2.8rem;
  color: #000000;
  margin-top: 1.4rem;
`;

const Label = styled.div`
  margin-top: 1.5rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 1.4rem;

  color: #000000;
`;

const TabRow = styled.div`
  display: flex;
  margin-top: 4.0rem;
  margin-bottom: 1.6rem;
`;

const TabText = styled.div`
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.8rem;
  margin-right: 2.6rem;

  color: ${(props) => (props.active ? "#000000" : "#C4C4C4")};
`;

const Amount = styled.div`
  color: #ff5c00;
`;
